let $element;
let $images;
let $video;
let $modal;
let $iFrame;

export function init() {
    let timer;
    let index = 0;

    $element = $('.js-screen-saver');
    $images = $('.js-screen-saver__img');
    $video = $('.js-screen-saver__video');
    $modal = $('.js-tt-configurator');
    $iFrame = $('.js-tt-configurator__iFrame');

    let $timerCountdown = $element.data('timer-countdown');
    let $imageDisplayTime = $element.data('image-display-time');

    function showScreenSaver() {
        $element.css('display', 'block');

        if ($images) {
            index = 0;
            showNextImg();
        }
    }

    function hideScreenSaver() {
        if ( ($element.css('display') === 'block') && ($modal.hasClass('show')) ) {
            $modal.modal('hide');

            if ($iFrame) {
                let iFrameSrc = $iFrame.attr('src');
                $iFrame.attr('src', iFrameSrc);
            }
        }

        $element.css('display', 'none');
    }

    function showNextImg() {
        $images.removeClass('active');
        $images.eq(index).addClass('active');

        index = (index + 1) % $images.length;

        setTimeout(showNextImg, $imageDisplayTime);
    }

    function resetTimer() {
        clearTimeout(timer);
        timer = setTimeout(showScreenSaver, $timerCountdown);
        hideScreenSaver();
    }

    $(window).on('load mousemove mousedown click scroll keypress', resetTimer);

    if ($video) {
        $video.on('pause ended volumechange seeking seeked ratechange fullscreenchange', resetTimer);
    }
}